"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*
  Wrap a component with Dismissable to make it conditionally visible based on a local storage key

  const InnerComponent = ({dismiss, hideIfDismissed}) => {
    const onClick = () => {
      dismiss();
      hideIfDismissed();
    };

    return <div onClick={onClick}/>;
  };

  const DismissableComponent = <Dismissable key={'foo'} render={InnerComponent}/>;
*/
var Dismissable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Dismissable, _React$Component);
  var _super = _createSuper(Dismissable);
  function Dismissable(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Dismissable);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "dismiss", function () {
      localStorage.setItem(_this.storageKey, 'true');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideIfDismissed", function () {
      var dismissed = localStorage.getItem(_this.storageKey) === 'true';
      _this.setState({
        dismissed: dismissed
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "dismissAndHide", function () {
      _this.dismiss();
      _this.hideIfDismissed();
    });
    var storageKeyPrefix = props.storageKeyPrefix;
    _this.storageKey = "".concat(storageKeyPrefix, "-dismissed");
    return _this;
  }
  (0, _createClass2["default"])(Dismissable, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.hideIfDismissed();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.dismissed) {
        return null;
      }
      var dismiss = this.dismiss,
        hideIfDismissed = this.hideIfDismissed,
        dismissAndHide = this.dismissAndHide;
      return this.props.render({
        dismiss: dismiss,
        hideIfDismissed: hideIfDismissed,
        dismissAndHide: dismissAndHide
      });
    }
  }]);
  return Dismissable;
}(React.Component);
var _default = exports["default"] = Dismissable;